(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["klinii-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.kfaq').forEach((section) => {
    section.querySelectorAll('[data-kfaq-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        const answer = document.getElementById(trigger.getAttribute('aria-controls'));
        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (answer) answer.hidden = expanded;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klinii-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('klinii-header').forEach((header) => {
    header.querySelectorAll('[data-localization-select]').forEach((select) => {
      if (select.dataset.localizationReady) return;
      select.dataset.localizationReady = 'true';
      select.addEventListener('change', () => {
        const form = select.form || select.closest('form');
        if (!form) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else HTMLFormElement.prototype.submit.call(form);
      });
    });
    if (header.dataset.ready || header.dataset.inlineReady) return;
    header.dataset.ready = 'true';
    const opener = header.querySelector('.kh__menu-button');
    const drawer = header.querySelector('.kh__drawer');
    const searchButton = header.querySelector('.kh__search-button');
    const search = header.querySelector('.kh__search');
    const closeDialog = (dialog) => { dialog?.close(); opener?.setAttribute('aria-expanded', 'false'); };
    opener?.addEventListener('click', () => { drawer.showModal(); opener.setAttribute('aria-expanded', 'true'); });
    header.querySelector('.kh__close')?.addEventListener('click', () => closeDialog(drawer));
    searchButton?.addEventListener('click', () => { search.showModal(); requestAnimationFrame(() => search.querySelector('input[type="search"]')?.focus()); });
    header.querySelector('.kh__search-close')?.addEventListener('click', () => closeDialog(search));
    [drawer, search].forEach((dialog) => dialog?.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(dialog); }));
    const predictiveInput = search?.querySelector('[data-predictive-input]');
    const predictiveResults = search?.querySelector('[data-predictive-results]');
    let searchTimer;
    const escapeHtml = (value) => String(value || '').replace(/[&<>"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[character]));
    predictiveInput?.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const term = predictiveInput.value.trim();
      if (term.length < 2) { predictiveResults.innerHTML = ''; return; }
      searchTimer = setTimeout(async () => {
        try {
          const endpoint = search.dataset.predictiveUrl;
          const response = await fetch(`${endpoint}.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last`);
          const data = await response.json();
          const products = data?.resources?.results?.products || [];
          predictiveResults.innerHTML = products.length ? `<div class="kh__search-grid">${products.map((item) => `<a class="kh__search-result" href="${escapeHtml(item.url)}">${item.image ? `<img src="${escapeHtml(item.image)}" alt="">` : ''}<span><b>${escapeHtml(item.title)}</b><small>${escapeHtml(item.price)}</small></span></a>`).join('')}</div>` : '';
        } catch (error) {
          predictiveResults.innerHTML = '';
        }
      }, 180);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klinii-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('klinii-slider').forEach((slider) => {
    if (slider.dataset.ready || slider.dataset.inlineReady) return;
    slider.dataset.ready = 'true';
    const track = slider.querySelector('.khero__track');
    const slides = [...slider.querySelectorAll('[data-slide]')];
    const dots = [...slider.querySelectorAll('[data-dot]')];
    const seconds = Number(slider.dataset.autoplay || 0);
    if (slides.length < 2) return;
    const firstClone = slides[0].cloneNode(true);
    const lastClone = slides[slides.length - 1].cloneNode(true);
    [firstClone, lastClone].forEach((clone) => {
      clone.removeAttribute('data-slide');
      clone.removeAttribute('data-shopify-editor-block');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      clone.classList.add('is-clone');
    });
    track.append(firstClone);
    track.prepend(lastClone);
    const physicalSlides = [...track.children];
    let physicalIndex = 1;
    let timer;
    let settleTimer;
    let resetting = false;
    const setDot = (next) => {
      const index = (next + slides.length) % slides.length;
      dots.forEach((dot) => dot.removeAttribute('aria-current'));
      void dots[index]?.offsetWidth;
      dots[index]?.setAttribute('aria-current', 'true');
    };
    const goPhysical = (next, smooth = true) => {
      physicalIndex = Math.max(0, Math.min(next, physicalSlides.length - 1));
      setDot(physicalIndex - 1);
      track.scrollTo({ left: physicalSlides[physicalIndex].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    };
    const activate = (next, smooth = true) => {
      const index = (next + slides.length) % slides.length;
      goPhysical(index + 1, smooth);
    };
    const nearestIndex = () => physicalSlides.reduce((best, slide, i) => Math.abs(slide.offsetLeft - track.scrollLeft) < Math.abs(physicalSlides[best].offsetLeft - track.scrollLeft) ? i : best, 0);
    const normalize = () => {
      if (resetting) return;
      physicalIndex = nearestIndex();
      setDot(physicalIndex - 1);
      if (physicalIndex !== 0 && physicalIndex !== physicalSlides.length - 1) return;
      resetting = true;
      physicalIndex = physicalIndex === 0 ? slides.length : 1;
      track.scrollTo({ left: physicalSlides[physicalIndex].offsetLeft, behavior: 'auto' });
      requestAnimationFrame(() => { resetting = false; });
    };
    const restart = () => {
      clearInterval(timer);
      slider.style.setProperty('--duration', `${seconds}s`);
      if (seconds > 0) timer = setInterval(() => { normalize(); goPhysical(physicalIndex + 1); }, seconds * 1000);
    };
    dots.forEach((dot, i) => dot.addEventListener('click', () => { activate(i); restart(); }));
    track.addEventListener('scroll', () => {
      if (resetting) return;
      clearTimeout(settleTimer);
      settleTimer = setTimeout(() => { normalize(); restart(); }, 90);
    }, { passive: true });
    track.addEventListener('touchend', () => setTimeout(normalize, 120), { passive: true });
    track.addEventListener('pointerup', () => setTimeout(normalize, 120), { passive: true });
    goPhysical(1, false);
    restart();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klinii-product-main"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.kproduct').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const stage = root.querySelector('[data-kproduct-stage]');
    const slides = [...root.querySelectorAll('[data-kproduct-media]')];
    const thumbs = [...root.querySelectorAll('[data-kproduct-thumb]')];
    const dots = [...root.querySelectorAll('[data-kproduct-dot]')];
    let index = 0;
    let touchStartX = 0;
    const showImage = (next, smooth = true) => {
      if (!slides.length) return;
      index = (next + slides.length) % slides.length;
      stage.scrollTo({ left: slides[index].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      thumbs[index]?.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'nearest', inline: 'nearest' });
    };
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => showImage(i)));
    dots.forEach((dot, i) => dot.addEventListener('click', () => showImage(i)));
    root.querySelector('[data-kproduct-prev]')?.addEventListener('click', () => showImage(index - 1));
    root.querySelector('[data-kproduct-next]')?.addEventListener('click', () => showImage(index + 1));
    stage?.addEventListener('scroll', () => {
      if (!slides[0]) return;
      const next = Math.round(stage.scrollLeft / slides[0].getBoundingClientRect().width);
      if (next !== index && next >= 0 && next < slides.length) {
        index = next;
        thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }
    }, { passive: true });
    stage?.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
    stage?.addEventListener('touchend', (event) => {
      const distance = touchStartX - event.changedTouches[0].clientX;
      if (Math.abs(distance) > 45) showImage(index + (distance > 0 ? 1 : -1));
    }, { passive: true });

const miniTrack = root.querySelector('.kproduct__mini-track');
if (miniTrack) {
  const miniCards = [...miniTrack.querySelectorAll('.kproduct__mini-card')];
  if (miniCards.length > 1) {
    const cloneReview = (card) => {
      const clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      return clone;
    };
    miniTrack.prepend(cloneReview(miniCards[miniCards.length - 1]));
    miniTrack.append(cloneReview(miniCards[0]));
    const physicalReviews = [...miniTrack.children];
    const reviewPosition = (position) => physicalReviews[position].offsetLeft;
    const nearestReview = () => physicalReviews.reduce((nearest, card, position) => Math.abs(reviewPosition(position) - miniTrack.scrollLeft) < Math.abs(reviewPosition(nearest) - miniTrack.scrollLeft) ? position : nearest, 0);
    let settleTimer;
    let pointerStart;
    let draggedReview = false;
    const normalizeReview = () => {
      const position = nearestReview();
      if (position === 0) miniTrack.scrollTo({ left: reviewPosition(miniCards.length), behavior: 'instant' });
      if (position === physicalReviews.length - 1) miniTrack.scrollTo({ left: reviewPosition(1), behavior: 'instant' });
    };
    const moveReview = (direction) => {
      normalizeReview();
      const position = Math.max(0, Math.min(physicalReviews.length - 1, nearestReview() + direction));
      miniTrack.scrollTo({ left: reviewPosition(position), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    miniTrack.addEventListener('scroll', () => { clearTimeout(settleTimer); settleTimer = setTimeout(normalizeReview, 180); }, { passive: true });
    miniTrack.addEventListener('scrollend', normalizeReview);
    miniTrack.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      moveReview(event.key === 'ArrowRight' ? 1 : -1);
    });
    miniTrack.addEventListener('pointerdown', (event) => { draggedReview = false; if (event.pointerType === 'mouse') pointerStart = event.clientX; });
    miniTrack.addEventListener('pointerup', (event) => {
      if (pointerStart === undefined) return;
      const distance = pointerStart - event.clientX;
      pointerStart = undefined;
      if (Math.abs(distance) > 30) { draggedReview = true; moveReview(distance > 0 ? 1 : -1); }
    });
    miniTrack.addEventListener('pointercancel', () => { pointerStart = undefined; });
    miniTrack.addEventListener('click', (event) => { if (draggedReview) { event.preventDefault(); event.stopPropagation(); } }, true);
    miniTrack.addEventListener('dragstart', (event) => event.preventDefault());
    miniTrack.scrollTo({ left: reviewPosition(1), behavior: 'instant' });
  }
}
    const sticky = root.querySelector('[data-kproduct-sticky]');
    const submit = root.querySelector('.kproduct__submit');
    const form = root.querySelector('.kproduct__form');
    const mainPrice = root.querySelector('[data-kproduct-price]');
    const mainCompare = root.querySelector('[data-kproduct-compare]');
    const submitPrice = root.querySelector('[data-kproduct-submit-price]');
    const stickyOffer = root.querySelector('[data-kproduct-sticky-offer]');
    const stickyPrice = root.querySelector('[data-kproduct-sticky-price]');
    const currency = window.Shopify?.currency?.active || 'EUR';
    const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(Number(cents || 0) / 100);
    root.querySelectorAll('[data-variant-price]').forEach((radio) => radio.addEventListener('change', () => {
      const price = Number(radio.dataset.variantPrice || 0);
      const compare = Number(radio.dataset.variantCompare || 0);
      const formattedPrice = radio.dataset.variantPriceFormatted || formatMoney(price);
      const formattedCompare = radio.dataset.variantCompareFormatted || formatMoney(compare);
      if (mainPrice) mainPrice.textContent = formattedPrice;
      if (mainCompare) {
        mainCompare.textContent = compare > price ? formattedCompare : '';
        mainCompare.hidden = compare <= price;
      }
      if (submitPrice) submitPrice.textContent = formattedPrice;
      if (stickyPrice) stickyPrice.textContent = formattedPrice;
      if (stickyOffer) stickyOffer.textContent = radio.dataset.variantTitle || '';
      showImage(Number(radio.dataset.variantMedia || 0));
    }));
    const selectedVariant = root.querySelector('[data-variant-price]:checked');
    if (selectedVariant) showImage(Number(selectedVariant.dataset.variantMedia || 0), false);
    const updateOffer = () => {
      const selected = root.querySelector('.kproduct__bundles label.is-selected');
      if (selected) {
        const total = Number(selected.dataset.offerTotal || 0);
        const compare = Number(selected.dataset.offerCompare || 0);
        const formattedTotal = selected.dataset.offerPrice || formatMoney(total);
        const formattedCompare = selected.dataset.offerCompareFormatted || formatMoney(compare);
        mainPrice.textContent = formattedTotal;
        if (mainCompare) {
          mainCompare.textContent = compare > total ? formattedCompare : '';
          mainCompare.hidden = compare <= total;
        }
        if (submitPrice) submitPrice.textContent = formattedTotal;
        stickyOffer.textContent = selected.dataset.offerLabel || '';
        stickyPrice.textContent = formattedTotal;
      }
    };
    root.querySelectorAll('[data-kproduct-quantity]').forEach((radio) => radio.addEventListener('change', () => {
      root.querySelectorAll('.kproduct__bundles label').forEach((label) => label.classList.remove('is-selected'));
      radio.closest('label').classList.add('is-selected');
      updateOffer();
    }));
    if (submit && sticky) {
      const observer = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { threshold: 0 });
      observer.observe(submit);
    }
    root.querySelector('[data-kproduct-sticky-submit]')?.addEventListener('click', () => submit?.click());
    root.querySelectorAll('.kproduct__sticky-copy,[data-kproduct-sticky-price]').forEach((control) => control.addEventListener('click', () => {
      (root.querySelector('.kproduct__bundles') || root.querySelector('.kproduct__variants') || form)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }));
    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!submit || submit.disabled) return;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Unable to add this item');
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        document.querySelectorAll('.kh__cart-count').forEach((count) => { count.textContent = cart.item_count; count.hidden = cart.item_count < 1; });
        const sectionsResponse = await fetch(`${window.Shopify?.routes?.root || '/'}?sections=cart-drawer-section`);
        const sections = await sectionsResponse.json();
        const wrapper = document.getElementById('shopify-section-cart-drawer-section');
        if (wrapper && sections['cart-drawer-section']) {
          const parsed = new DOMParser().parseFromString(sections['cart-drawer-section'], 'text/html');
          const replacement = parsed.getElementById('shopify-section-cart-drawer-section');
          if (replacement) wrapper.replaceWith(replacement);
        }
        await customElements.whenDefined('theme-drawer');
        document.getElementById('cart-drawer')?.open();
      } catch (error) {
        form.submit();
      } finally {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      }
    });
    updateOffer();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klinii-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('klinii-product-slider').forEach((slider) => {
    if (slider.dataset.ready || slider.dataset.inlineReady) return;
    slider.dataset.ready = 'true';
    const track = slider.querySelector('[data-track]');
    const cards = [...track.querySelectorAll('.kproducts__card')];
    if (cards.length < 2) return;
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    const step = cards[0].getBoundingClientRect().width + gap;
    const cloneCount = Math.min(cards.length, Math.max(1, Math.ceil(track.clientWidth / step)));
    const makeClone = (card) => { const clone = card.cloneNode(true); clone.classList.add('is-clone'); clone.setAttribute('aria-hidden', 'true'); clone.setAttribute('inert', ''); return clone; };
    cards.slice(0, cloneCount).forEach((card) => track.append(makeClone(card)));
    cards.slice(-cloneCount).reverse().forEach((card) => track.prepend(makeClone(card)));
    const physicalCards = [...track.querySelectorAll('.kproducts__card')];
    let physicalIndex = cloneCount;
    let settleTimer;
    let resetting = false;
    const position = (index) => physicalCards[index].offsetLeft - track.offsetLeft;
    const nearestIndex = () => physicalCards.reduce((best, card, i) => Math.abs(position(i) - track.scrollLeft) < Math.abs(position(best) - track.scrollLeft) ? i : best, 0);
    const go = (index, smooth = true) => {
      physicalIndex = Math.max(0, Math.min(index, physicalCards.length - 1));
      track.scrollTo({ left: position(physicalIndex), behavior: smooth ? 'smooth' : 'auto' });
    };
    const normalize = () => {
      if (resetting) return;
      physicalIndex = nearestIndex();
      if (physicalIndex >= cloneCount && physicalIndex < cloneCount + cards.length) return;
      resetting = true;
      physicalIndex = physicalIndex < cloneCount ? physicalIndex + cards.length : physicalIndex - cards.length;
      track.scrollTo({ left: position(physicalIndex), behavior: 'auto' });
      requestAnimationFrame(() => { resetting = false; });
    };
    const move = (direction) => { normalize(); go(physicalIndex + direction); };
    slider.querySelector('[data-prev]')?.addEventListener('click', () => move(-1));
    slider.querySelector('[data-next]')?.addEventListener('click', () => move(1));
    track.addEventListener('scroll', () => { if (resetting) return; clearTimeout(settleTimer); settleTimer = setTimeout(normalize, 90); }, { passive: true });
    track.addEventListener('touchend', () => setTimeout(normalize, 120), { passive: true });
    track.addEventListener('pointerup', () => setTimeout(normalize, 120), { passive: true });
    go(cloneCount, false);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klinii-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('klinii-review-slider').forEach((slider) => {
    if (slider.dataset.ready || slider.dataset.inlineReady) return;
    slider.dataset.ready = 'true';
    const track = slider.querySelector('[data-track]');
    const cards = [...slider.querySelectorAll('.kreviews__card')];
    if (cards.length < 2) return;
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    const step = cards[0].getBoundingClientRect().width + gap;
    const cloneCount = Math.min(cards.length, Math.max(1, Math.ceil(track.clientWidth / step)));
    const makeClone = (card) => { const clone = card.cloneNode(true); clone.classList.add('is-clone'); clone.removeAttribute('data-shopify-editor-block'); clone.setAttribute('aria-hidden', 'true'); clone.setAttribute('inert', ''); return clone; };
    cards.slice(0, cloneCount).forEach((card) => track.append(makeClone(card)));
    cards.slice(-cloneCount).reverse().forEach((card) => track.prepend(makeClone(card)));
    const physicalCards = [...track.querySelectorAll('.kreviews__card')];
    let physicalIndex = cloneCount;
    let settleTimer;
    let resetting = false;
    const position = (index) => physicalCards[index].offsetLeft - track.offsetLeft;
    const nearestIndex = () => physicalCards.reduce((best, card, i) => Math.abs(position(i) - track.scrollLeft) < Math.abs(position(best) - track.scrollLeft) ? i : best, 0);
    const go = (index, smooth = true) => {
      physicalIndex = Math.max(0, Math.min(index, physicalCards.length - 1));
      track.scrollTo({ left: position(physicalIndex), behavior: smooth ? 'smooth' : 'auto' });
    };
    const normalize = () => {
      if (resetting) return;
      physicalIndex = nearestIndex();
      if (physicalIndex >= cloneCount && physicalIndex < cloneCount + cards.length) return;
      resetting = true;
      physicalIndex = physicalIndex < cloneCount ? physicalIndex + cards.length : physicalIndex - cards.length;
      track.scrollTo({ left: position(physicalIndex), behavior: 'auto' });
      requestAnimationFrame(() => { resetting = false; });
    };
    const move = (direction) => { normalize(); go(physicalIndex + direction); };
    slider.querySelector('[data-prev]')?.addEventListener('click', () => move(-1));
    slider.querySelector('[data-next]')?.addEventListener('click', () => move(1));
    track.addEventListener('scroll', () => { if (resetting) return; clearTimeout(settleTimer); settleTimer = setTimeout(normalize, 90); }, { passive: true });
    track.addEventListener('touchend', () => setTimeout(normalize, 120), { passive: true });
    track.addEventListener('pointerup', () => setTimeout(normalize, 120), { passive: true });
    go(cloneCount, false);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
